import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const CnpjInput = forwardRef((props, ref) => (
  <InputTemplate {...props} formato="##.###.###/####-##" ref={ref} />
));

export default CnpjInput;
